import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import CatalogoApp from "./CatalogoApp";
import "./styles/styles.scss";
import "sweetalert2/dist/sweetalert2.min.css";

// Redirect subdomain distribucion to root domain
if (window.location.hostname === "distribucion.merrycolor.mx") {
    window.location.replace(
        "https://merrycolor.mx" + window.location.pathname + window.location.search
    );
} else {
    ReactDOM.render(
        <HelmetProvider>
            <CatalogoApp />
        </HelmetProvider>,
        document.getElementById("root")
    );
}
